export const pageDetails = [
  {
    checkbox: true,
    page: "Employee",
    page_slug:"employee",
    status: "Active",
    key: "1"
  },
  {
    checkbox: true,
    page: "Clients",
    page_slug:"clients",
    status: "Active",
    key: "2"
  },
  {
    checkbox: true,
    page: "Projects",
    page_slug:"projects",
    status: "Active",
    key: "3"
  },
  {
    checkbox: true,
    page: "Tickets",
    page_slug:"tickets",
    status: "Active",
    key: "4"
  },
  {
    checkbox: true,
    page: "Contacts",
    page_slug:"contacts",
    status: "Active",
    key: "5"
  },
  {
    checkbox: true,
    page: "Companies",
    page_slug:"companies",
    status: "Active",
    key: "6"
  },
  {
    checkbox: true,
    page: "Deals",
    page_slug:"deals",
    status: "Active",
    key: "7"
  },
  {
    checkbox: true,
    page: "Leads",
    page_slug:"leads",
    status: "Active",
    key: "8"
  },
  {
    checkbox: true,
    page: "Pipeline",
    page_slug:"pipeline",
    status: "Active",
    key: "9"
  },
  {
    checkbox: true,
    page: "Activities",
    page_slug:"activities",
    status: "Active",
    key: "10"
  },
];
